import {
  Dropdown,
  DropdownOption,
} from "components/designV2/dropdown/dropdown";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  PassSettingControl,
  PassSettingControls,
} from "./passSettingsV2.styled";
import { SystemSettingRow } from "./systemSettingRow.component";

export const CompanyVacationEarningTypeSetting: React.FC<{
  value: string;
  onChange: (value: string) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const options: DropdownOption[] = [
    {
      label: t("System.CompanyVacationEarningTypeFixedMonthly"),
      value: "FixedMonthly",
    },
    {
      label: t("System.CompanyVacationEarningTypeCalendarDays"),
      value: "CalendarDays",
    },
  ];

  return (
    <SystemSettingRow
      title={t("System.CompanyVacationEarningType")}
      description={t("System.CompanyVacationEarningTypeInfo")}
      controlVerticalAlign="center"
    >
      <PassSettingControls>
        <PassSettingControl>
          <Dropdown
            ariaLabel={t("System.CompanyVacationEarningType")}
            options={options}
            value={value}
            onChange={onChange}
          />
        </PassSettingControl>
      </PassSettingControls>
    </SystemSettingRow>
  );
};
